var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentsLinear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8332 7.28508C14.5566 7.24539 14.2786 7.21565 13.9998 7.19591M3.99984 8.80425C3.71539 8.78425 3.43762 8.75453 3.1665 8.71508M11.0832 8.00008C11.0832 8.55262 10.8637 9.08252 10.473 9.47322C10.0823 9.86392 9.55237 10.0834 8.99984 10.0834C8.4473 10.0834 7.9174 9.86392 7.5267 9.47322C7.136 9.08252 6.9165 8.55262 6.9165 8.00008C6.9165 7.44755 7.136 6.91764 7.5267 6.52694C7.9174 6.13624 8.4473 5.91675 8.99984 5.91675C9.55237 5.91675 10.0823 6.13624 10.473 6.52694C10.8637 6.91764 11.0832 7.44755 11.0832 8.00008Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99984 14.2501C7.88984 14.7684 6.43067 15.0834 4.83317 15.0834C3.94484 15.0834 3.09984 14.9859 2.33317 14.8109C1.08317 14.5242 0.666504 13.7717 0.666504 12.4884V3.51175C0.666504 2.69091 1.53317 2.12758 2.33317 2.31091C3.09984 2.48591 3.94484 2.58341 4.83317 2.58341C6.43067 2.58341 7.88984 2.26841 8.99984 1.75008C10.1098 1.23175 11.569 0.916748 13.1665 0.916748C14.0548 0.916748 14.8998 1.01425 15.6665 1.18925C16.9848 1.49175 17.3332 2.26675 17.3332 3.51175V12.4884C17.3332 13.3092 16.4665 13.8726 15.6665 13.6892C14.8998 13.5142 14.0548 13.4167 13.1665 13.4167C11.569 13.4167 10.1098 13.7317 8.99984 14.2501Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsLinear);
export default __webpack_public_path__ + "static/media/payments-linear.4ef5c93ef43ca3446560ba6e25872c57.svg";
export { ForwardRef as ReactComponent };